$(document).ready(function(){$('img[src="https://cdn.shopify.com/s/files/1/0789/1838/5938/files/New_LOGO_TM_BLACK_1.png?v=1747242948"]').attr('alt', 'Rebel pouches logo in black');

$('img[src="https://rebelsupps.store/cdn/shop/files/New_LOGO_TM_BLACK.png?v=1722385044&width=300"]').attr('alt', 'Rebel pouches logo in black');



$('img[src="https://cdn.shopify.com/s/files/1/0677/8041/1645/files/icon-usa-white_b7882184-4db7-48a1-bba2-8fa2d8b3047a.svg?v=1725387864"]').attr('alt', 'usa flag');

$('img[src="https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/347e59b1-78eb-4b4d-ab06-d76b3242490d"]').attr('alt', 'Tick icon');

$('img[src="https://cdn.shopify.com/s/files/1/0677/8041/1645/files/Tiktok-icon.svg?v=1725427022"]').attr('alt', 'TikTok icon');

$('img[src="https://cdn.shopify.com/s/files/1/0677/8041/1645/files/Instagram-icon_0dbf3e07-7f12-4bdc-bfb8-d1e40a232aa1.svg?v=1725427003"]').attr('alt', 'Instagram icon');

$('img[src="https://cdn.shopify.com/s/files/1/0677/8041/1645/files/Rebel-White-Logo.png?v=1725427576"]').attr('alt', 'Rebel pouches logo in white');
$('img[src="https://cdn.shopify.com/s/files/1/0677/8041/1645/files/icon-2_694c2907-e9ac-4ff6-aa33-365ca1094e98.svg?v=1725385093"]').attr('alt', 'Truck icon');
$("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/VP_Main_Listing_Image_Compressed.webp?v=1747755987&width=1800\"]").attr("alt", "Rebel Energy Pouches in Wintergreen, Mango, and Cool Mint flavors");

    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/6fdac0a8-1e21-4082-9905-ece7b9074aaf?width=1800\"]").attr("alt", "Rebel Pouches energy boost products");


    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/b36f5965-89bb-4d4d-bdf5-6ffa473bb911?width=1800\"]").attr("alt", "Coconut fiber texture close-up");

    
    $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/Icon-FlavorArtboard-3.webp?v=1747931989\"]").attr("alt", "Rebel Pouches logo");

    $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/Icon-FlavorArtboard-4.webp?v=1747931989\"]").attr("alt", "Rebel Pouches logo");

 
    $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/Icon-FlavorArtboard-2.webp?v=1747931989\"]").attr("alt", "Rebel Pouches logo");

  
    $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/Icon-FlavorArtboard-1.webp?v=1747931989\"]").attr("alt", "Rebel Pouches logo");


    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/9c58735e-a695-464b-a33e-d9870e3884fa\"]").attr("alt", "Man holding colorful containers, shirtless, with surprised expression");

  
    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/aad5fd17-869b-4e63-b425-7c222bb01331\"]").attr("alt", "Hand holding pouch next to laptop on wooden table");

    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/67454f1c-26f8-4728-9069-80eabb8ebcf4\"]").attr("alt", "Man holding up Rebel Wintergreen pouch");


    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/4472a2d6-3119-4a52-8478-4094a4849530\"]").attr("alt", "Man in black hoodie holding a small item, looking tired");


    $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/made-in-usa_png.webp?v=1736493730\"]").attr("alt", "American flag icon in a circle");


    $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/money_back_png.webp?v=1736500176\"]").attr("alt", "Dollar sign in a circular arrow icon");


    $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/full_transparency_png.webp?v=1736500162\"]").attr("alt", "Grey checkmark icon in a circle");


    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/547bf79e-e86e-4dc1-9630-f770c31846d6\"]").attr("alt", "Man in white shirt and cap holding pouch over cups labeled US and them");


    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/5db04e51-464f-4801-9ae5-771c642aae2e\"]").attr("alt", "Man holding Rebel Supplements products, wearing white polo shirt");

    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/27960ee5-ba08-4f52-a9d4-9bb95821218d\"]").attr("alt", "Man in camouflage shirt and sunglasses walking beside tree");

   
    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/47a10a7f-a098-4b6f-baea-48b9c35a8767\"]").attr("alt", "Man in white Rebel Supplements shirt sitting at table with cups and product containers");


    $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/SM1_-_v1_-_MINT_1__11zon.webp?v=1747157192\"]").attr("alt", "Rebel Energy Pouches Cool Mint packaging");
$("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/a7117d9e-d336-44bc-83b9-4648ae6a1c2b?width=1800\"]").attr("alt", "Infographic for Rebel Energy Pouches listing bioactive ingredients");
 $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/f745b6f8-0a03-4564-a9dd-ebbd597b2c0e?width=1800\"]").attr("alt", "Infographic for Rebel Energy Pouches listing caffeine ");
  $("img[src=\"https://cdn.shopify.com/s/files/1/0789/1838/5938/files/Compnovignetting-ezgif.com-optimize.gif?v=1748025497\"]").attr("alt", "Rebel pouches in cool mint,mango and wintergreen flavour");
     $("img[src=\"https://cdn.shopify.com/s/files/1/0677/8041/1645/files/icon-payments.svg?v=1725428158\"]").attr("alt", "Payment methods available icon");
  $('img[src="https://tracker.metricool.com/c3po.jpg?hash=e885fe80f6f0537a218b24af034136ce"]').attr('alt', 'Metricool tracking');
 $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/f518bf88-dfaf-4397-86d7-8a9f2c560cb1\"]").attr("alt", "Aiden and daniel showing big idea pitch entry passes");

    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/5a26ed71-f2b2-4d55-a012-fe899994ca4e\"]").attr("alt", "Person on motorcycle wearing Thrasher hoodie and helmet");

    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/71e2d3ab-1913-4d16-a659-6a4896751a1b\"]").attr("alt", "Rebel Energy Pouches containers in orange, green, and blue");

 
    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/85eb281e-5813-45a0-9124-5a9374cb72e2\"]").attr("alt", "Hands holding tin of Rebel Pouches tobacco-free snus");

    
    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/dc2a8a9b-c757-4fc1-881f-24330c53ae55\"]").attr("alt", "Hand holding blue tin container labeled \"REBEL\" and \"WATERPROOF");


    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/cbd4e418-c43f-4586-8fe3-984aae3c67a4\"]").attr("alt", "Hand holding green and white Rebel Energy Pouched Gum container");


    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/ceb60e44-467a-4388-92ab-821bdb5bd95a\"]").attr("alt", "Red baseball glove, baseball, and Rebel Pouches on green turf");

    $("img[src=\"https://assets.replocdn.com/projects/1ba30756-60a5-4704-b96c-ca54873ed464/fc880eeb-bd83-4034-b633-2e5af538e4bc\"]").attr("alt", "Man in black Rebel Supplements clothing holding supplement containers");
    $("img[src=\"//rebelpouches.com/cdn/shop/files/Clean_Energy_Explained.jpg?v=1744690596\"]").attr("alt", "Hands holding white nicotine pouches on green background");

    $('img[src="//rebelpouches.com/cdn/shop/files/The_Science_Behind_Oral_Absorption.jpg?v=1744690596"]').attr('alt', 'Person doing research on a laptop');

    $("img[src=\"//rebelpouches.com/cdn/shop/files/Customizable_Experience.jpg?v=1744690596\"]").attr("alt", "Caffeine pouches vs coffee/energy drinks comparison chart");
     $("img[src=\"//rebelpouches.com/cdn/shop/files/1_13b52e04-01e2-4ffa-801c-a55e0ddda9d0.jpg?v=1744606748\"]").attr("alt", "Coffee beans, energy pouches, mango slice, and mint leaves on yellow background");

 
    $("img[src=\"//rebelpouches.com/cdn/shop/files/2.jpg?v=1744606748\"]").attr("alt", "Energy pouches and fruit, mint leaves on white surface");


   
    $("img[src=\"//rebelpouches.com/cdn/shop/files/energy-pouches.jpg?v=1744345867\"]").attr("alt", "Man split in two, one side smoking, the other holding energy capsules");


    $("img[src=\"//rebelpouches.com/cdn/shop/files/symbolizing-a-healthier-or-superior.jpg?v=1744345875\"]").attr("alt", "Shelf of nicotine product cans with one highlighted can");


    $("img[src=\"//rebelpouches.com/cdn/shop/files/The_smarter_pouch_is_clear.jpg?v=1744345875\"]").attr("alt", "Seesaw comparing caffeine and nicotine pouches benefits");
    $("img[src=\"//rebelpouches.com/cdn/shop/files/3.jpg?v=1744606747\"]").attr("alt", "Comparison of nicotine pouches and energy pouches");
     $("img[src=\"//rebelpouches.com/cdn/shop/files/The_Best_Caffeine_Hack_for_Fitness_Junkies.jpg?v=1744258816\"]").attr("alt", "Rebel pouches and healthy energy options");

     $("img[src=\"//rebelpouches.com/cdn/shop/files/1.jpg?v=1744173144\"]").attr("alt", "Man in green shirt eating caffeine pouch with mango and mint");
    $("img[src=\"//rebelpouches.com/cdn/shop/files/gym-goers_and_workout_equipment.jpg?v=1744259545\"]").attr("alt", "Muscular man in black tank top opening gym bag");

     $("img[src=\"//rebelpouches.com/cdn/shop/files/energy-01.jpg?v=1744001897\"]").attr("alt", "Natural energy boosters, fruits, and drinks");
 $("img[src=\"//rebelpouches.com/cdn/shop/files/b4e091f6-b5cc-481b-90ee-b77b8de827e6.jpg?v=1743857052\"]").attr("alt", "Man walking away from cigarettes on a path to bright light");


    $("img[src=\"//rebelpouches.com/cdn/shop/files/02.png?v=1744038010\"]").attr("alt", "Nicotine withdrawal timeline infographic");
    $("img[src=\"//rebelpouches.com/cdn/shop/files/energy-02.jpg?v=1744091883\"]").attr("alt", "Rebel Energy Pouches packaging on colorful background");
$('input#YQNum').attr('aria-label', 'Enter your tracking number');

    let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;


   
    if ( $('textarea[name="g-recaptcha-response"]').length) {

$('textarea[name="g-recaptcha-response"]').attr('aria-label', 'reCAPTCHA verification');

        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}

    console.log("ready");
});